// @flow
import React, { PureComponent } from 'react';
import viFetchAdapter from '../../viFetchAdapter';

class CityViewer extends PureComponent {
  componentDidMount() {
    const isId = /[0-9]*/.test(this.props.idOrName.toString());
    if (!isId) {
      this.setState({
        cityName: this.props.idOrName,
      });
      return;
    }
    this.loadFromDb(this.props.idOrName);
  }

  loadFromDb = async (id) => {
    const { data } = await viFetchAdapter
      .get(`/api/location/getCityById?id=${id}`);
    this.setState({
      cityName: data.city.CityName,
    });
  }

  state = {
    cityName: '',
  }

  props: {
    idOrName: string | number,
  }

  render() {
    return <span>{this.state.cityName}</span>
  }
}

export default CityViewer;



// WEBPACK FOOTER //
// ./src/components/CityViewer/index.js